import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function SchedulingProjectAPI(): BringozApi {
  return {
    base: `/schedulingProject`,
    infiniteScroll: {
      address: `/schedulingProject`,
      cmd: 'GET'
    },
    actions: {
    }
  }
}

angular
  .module('bringoz.admin.scheduling-project')
  .factory('SchedulingProjectAPI', SchedulingProjectAPI);
